<template>
  <div
    v-if="isMobileVersion && isShowOverlay"
    class="mobile-overlay"
    @touchmove="onOverlayClick"
    @click="onOverlayClick"
  >
    <div class="mobile-ovarlay-vertical" v-if="isVerticalScreen">
      {{ verticalText }}
    </div>
    <div class="mobile-overlay-inner">
      <div class="mobile-overlay-finger"></div>
      <div class="mobile-ovarlay-font">
        {{ overlayText }}
      </div>
    </div>
  </div>
</template>

<script>
const getScreenOrientation = () => {
  const screenOrientation = screen?.orientation?.type || 'portrait-primary'
  return screenOrientation
}

export default {
  name: 'MobileOverlay',
  computed: {
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    overlayText() {
      const vertical = this.isVerticalScreen
        ? 'Также мы рекомендуем перевернуть телефон горизонтально для более удобного просмотра'
        : ''
      return `Листайте вправо для просмотра полной информации. ${vertical}`
    },
  },
  methods: {
    onOrientationChange() {
      const screenOrientation = getScreenOrientation()
      this.isVerticalScreen = screenOrientation === 'portrait-primary'
    },
    onOverlayClick() {
      this.isShowOverlay = false
    },
  },
  data() {
    return {
      isVerticalScreen: getScreenOrientation() === 'portrait-primary',
      verticalText: 'Переверните горизонтально ваш телефон',
      isShowOverlay: true,
    }
  },
  mounted() {
    window.addEventListener('orientationchange', this.onOrientationChange)
  },
  unmounted() {
    window.removeEventListener('orientationchange', this.onOrientationChange)
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400&display=swap');
</style>

<style scoped>
.mobile-overlay {
  z-index: 1000 !important;
  position: fixed;
  background-color: rgba(0, 0, 0, 31%);
  width: 100vw;
  height: 100vh;
}
.mobile-overlay-inner {
  top: 40%;
  width: 60vw;
  right: 5%;
  height: 200px;
  position: absolute;
}
.mobile-overlay-finger {
  /* TODO */
  background-image: url(https://dev-io.winwinapp.ru/icon_finger.png);
  background-repeat: no-repeat;
  width: 25vw;
  position: relative;
  height: 100px;
  animation-name: finger-to-right;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.mobile-ovarlay-font {
  font-size: 22px;
  font-weight: 400;
  color: white;
  margin-top: 10px;
  font-family: Inter;
  line-height: 28px;
}
.mobile-ovarlay-vertical {
  position: absolute;
  top: 5vh;
  left: 5vw;
  font-size: 22px;
  font-weight: 400;
}
@keyframes finger-to-right {
  from {
    left: 0;
  }
  to {
    left: 30%;
  }
}
</style>
